import netcoServer from '../../apis/netcoServer';
import {CHECK_BASIC_AUTHENTICATION, SET_CONFIGURATION_PARAM} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import getConfiguration from "./getConfiguration";
import modalDismiss from "../modal/modalDismiss";
import loadingCall from "../helpers/loadingCall";
import isLoggedIn from '../auth/isLoggedIn';
import admin from '../../const/admin';

const setConfigurationParam= (formValues) => async (dispatch,getState) => {
  const language=getState().auth.language;
  const onSuccessPayload = () => {
    if(formValues.name==='entrustServer') {
      dispatch({type: CHECK_BASIC_AUTHENTICATION, payload: {auth: {entrust: formValues.value}}});
    }
      return infoPayload('success', admin[language].updateParams);
  };
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/setConfigurationParam', formValues));
  handleResponse(dispatch, response, SET_CONFIGURATION_PARAM, onSuccessPayload, null, [getConfiguration, modalDismiss, isLoggedIn]);
};
export default setConfigurationParam;